import {DEFAULT_LANGUAGE_TO_LOCALE} from '../constants/constants';

export const getLocaleFromDefaultLanguage = (defaultLanguage) =>
    DEFAULT_LANGUAGE_TO_LOCALE[defaultLanguage] || null;


// WEBPACK FOOTER //
// ./src/utils/localeMapHelper.js